<template>
  <div
    class="input-field"
    :class="{'error': validationError}"
  >
    <label
      v-if="label"
      :class="required ? 'required' : ''"
    >
      {{ label }}
    </label>

    <textarea
      ref="textarea"
      v-model="model"
      :rows="rows"
      :placeholder="placeholder"
      :required="required"
    />

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  rows: {
    type: [Number, String],
    default: 4,
  },
  required: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: [Boolean, String],
    default: null,
  },
});

const model = defineModel();
</script>
